<template>
  <footer class="container-fluid image-bg py-6 py-md-7">
    <div class="container">
      <div class="row">
        <div class="col-12 col-md-4">
          <img
            id="footer-logo"
            src="@/assets/csca-stacked-logo.svg"
            alt="CS Capital Advisors"
          />
        </div>
        <div class="col-12 col-md-4 offset-md-1">
          <p>
            300 Park Avenue, Suite 218<br/> New York, NY 10022
          </p>
          <p>
            Office:
            <a href="tel:(212) 446-9177">(212) 446-9177</a>
            <br />Fax: (212) 446-9181
            <br />
            <a href="mailto:CSCA@cscapitaladvisors.com"
              >CSCA@cscapitaladvisors.com</a
            >
          </p>
        </div>
        <div class="col-12 col-md-3">
          <nav id="footer-nav">
            <router-link :to="{ name: 'Firm-Overview' }"
              >Firm Overview</router-link
            >
            <router-link :to="{ name: 'Financial-Advisory' }"
              >Financial Advisory</router-link
            >
            <router-link :to="{ name: 'Asset-Management' }"
              >Asset Management</router-link
            >
            <router-link :to="{ name: 'Transactions' }"
              >Transactions</router-link
            >
            <router-link :to="{ name: 'Leadership' }">Leadership</router-link>
            <router-link :to="{ name: 'Careers' }">Careers</router-link>
            <router-link :to="{ name: 'Contact' }">Contact</router-link>
          </nav>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
footer {
  background-image: url(../assets/footer-bg.jpg);
}
#footer-logo {
  max-width: 100%;
  margin-bottom: 2rem;
}
p {
  color: #ffffff;
  &.fine-print {
    font-size: 0.875rem;
    line-height: 1.5em;
  }
}
a {
  color: #ffffff;
  transition: color 0.3s ease;
  &:hover {
    color: #dcb249;
    text-decoration: none;
  }
}
#footer-nav {
  a {
    display: block;
    margin-bottom: 0.5rem;
  }
}
</style>
